import { render, staticRenderFns } from "./BaseLearningView.vue?vue&type=template&id=3dc2af9e&scoped=true&"
import script from "./BaseLearningView.vue?vue&type=script&lang=js&"
export * from "./BaseLearningView.vue?vue&type=script&lang=js&"
import style0 from "./BaseLearningView.vue?vue&type=style&index=0&id=3dc2af9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2af9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
